import { Icon } from "@chakra-ui/react";

const CheckIcon = (props: any) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      id="Subtract"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM17.2481 8.0547C17.6295 8.4361 17.6295 9.05447 17.2481 9.43587L10.7372 15.9467C10.3558 16.3281 9.73747 16.3281 9.35607 15.9467L6.75172 13.3424C6.37032 12.961 6.37032 12.3426 6.75172 11.9612C7.13312 11.5798 7.75149 11.5798 8.13289 11.9612L10.0467 13.875L15.867 8.0547C16.2484 7.6733 16.8667 7.6733 17.2481 8.0547Z"
      fill="currentColor"
    />
  </Icon>
);

export default CheckIcon;
